import { IconPrev } from 'components/ui/icons';
import styles from '../control-track.module.scss';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { trackSwith } from 'store/slices/player.slices';
import { clsx } from 'clsx';

export const BtnPrevTrack = () => {
  const dispatch = useAppDispatch();

  /* индекс активного трека из списка */
  const { activeTrackNum } = useAppSelector((store) => store.player);

  /* Переключвает назад если это не
      самый первый трек в списке */
  const onPrevTrack = () => {
    if (activeTrackNum > 0) {
      dispatch(trackSwith(activeTrackNum - 1));
    }
  };

  return (
    <button className={clsx(styles.btn, styles.btnPrev)} onClick={onPrevTrack}>
      <IconPrev />
    </button>
  );
};
